import { Pipe, PipeTransform } from '@angular/core';

import { TableData } from '../models/table-data';
import { ComponentDataSelectorUtil } from '../utils/component-data-selector.util';

@Pipe({
	name: 'cellFormattedValue'
})
export class CellFormattedValuePipe implements PipeTransform {
	public transform(table: TableData, headerXName: string, portfolioIndex: number): string {
		return ComponentDataSelectorUtil.cellFormattedValueSelector(table, headerXName, portfolioIndex);
	}
}
